import React, { useEffect, useState } from 'react';
import '../styles/Leaderboard.css';
import { Header, Footer } from '../components';
import { checkOnAuthStateChanged } from '../functions';

function Leaderboard() {
    const [loggedIn, setLoggedIn] = useState(null);

    useEffect(() => {
        
        const fetchUserData = async() => {
            const user = await checkOnAuthStateChanged();
            if ( user.status === 200 ) {
                setLoggedIn(true);
            }
            else {
                setLoggedIn(false);
            }
        }

        fetchUserData();

    }, []);

    return (
        <div className="leaderboard-outer-container">
            <Header
                loggedIn={loggedIn}
            />
            <div className="leaderboard-inner-container">

            </div>
            <Footer />
        </div>
    )
};

export default Leaderboard;